import { useCookies } from "react-cookie";
import { useEventCallback } from "usehooks-ts";

export function useSelectedCompany() {
	const [cookies, setCookie] = useCookies(["COMPANY_ID"]);

	const selected = Number(cookies.COMPANY_ID);

	const setSelected = useEventCallback((value: number) => {
		setCookie("COMPANY_ID", value.toString(), { path: "/", httpOnly: false });
	});

	return [selected, setSelected] as const;
}
